(() => {
  const product = document.querySelector('.crealux-product');
  if (!product) return;
  const form = product.querySelector('form[action*="/cart/add"]');
  if (!form) return;
  const button = form.querySelector('[data-add-to-cart]');
  const price = product.querySelector('[data-selected-variant-price]');
  const colorLabel = form.querySelector('[data-selected-variant-label]');
  const variantSelect = form.querySelector('select[data-variant-choice]');
  const variantRadios = [...form.querySelectorAll('input[type="radio"][data-variant-choice]')];

  const selectedVariant = () => variantSelect?.selectedOptions[0] || variantRadios.find((radio) => radio.checked);
  const update = () => {
    const variant = selectedVariant();
    if (!variant) return;
    if (price) price.textContent = variant.dataset.price || price.textContent;
    if (colorLabel) colorLabel.textContent = `Couleur : ${variant.dataset.label || ''}`;
    if (button) {
      const available = variant.dataset.available === 'true';
      button.disabled = !available;
      button.textContent = available ? 'Ajouter au panier' : 'Épuisé';
    }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.value);
    window.history.replaceState(window.history.state, '', url.toString());
  };
  variantSelect?.addEventListener('change', update);
  variantRadios.forEach((radio) => radio.addEventListener('change', update));
})();
